import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { PayformStatusCd } from '@xpo-ltl/sdk-common';
import { takeUntil } from 'rxjs/operators';
import { PayformsFilter } from '../../classes/payforms-filter';
import { payformsFilterStateSelector, removePayformsFilterStatusAction, setPayformsFilterStateAction } from '@app/state/payforms-filter';
import { Store } from '@ngrx/store';
import { Unsubscriber } from 'app/utils/angular-utils/classes';

@Component({
  selector: 'payforms-filter-chips',
  templateUrl: './payforms-filter-chips.component.html',
  styleUrls: ['./payforms-filter-chips.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PayformsFilterChipsComponent implements OnInit, OnDestroy {
  private unsubscriber = new Unsubscriber();

  public currentFilter: PayformsFilter;
  public payformStatusCode = PayformStatusCd;

  constructor(private cdr: ChangeDetectorRef, private store: Store) {}

  removeStatus(status: PayformStatusCd) {
    this.store.dispatch(removePayformsFilterStatusAction({ status }));
  }

  remove(fieldName: string) {
    this.currentFilter[`${fieldName}`] = undefined;
    this.store.dispatch(setPayformsFilterStateAction({ filter: this.currentFilter }));
  }

  hasAnyFilter(): boolean {
    return (
      !!this.currentFilter &&
      (!!this.currentFilter.sicCd ||
        !!this.currentFilter.employeeName ||
        (!!this.currentFilter.status && this.currentFilter.status.length > 0) ||
        !!this.currentFilter.toDate ||
        !!this.currentFilter.fromDate)
    );
  }

  ngOnInit() {
    this.store
      .select(payformsFilterStateSelector)
      .pipe(takeUntil(this.unsubscriber.done))
      .subscribe(value => {
        this.currentFilter = value;
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy() {
    this.unsubscriber.complete();
  }
}
